// extracted by mini-css-extract-plugin
module.exports = {"modal":"kO","modalContent":"lO","modalOverlay":"mO","copy":"nO","modalBtnContainer":"oO","btnStay":"pO","disabled":"qO","btnContinue":"rO"};